module.exports = __webpack_public_path__ + "img/VC.bd0bfc7e.svg";